import styled from "styled-components";

export const ToTopButton = styled.div`
position: fixed;
width: 100%;
left: 93%;
bottom: 100px;
height: 20px;
font-size: 3rem;
z-index: 1;
cursor: pointer;
color: green;
`
